























import './viewerTypes.ts'
import Vue from 'vue'
import ImageFrame from './ImageFrame.vue'

export default Vue.extend({
  components: { ImageFrame },
  props: {
    image: {
      type: Object,
      default: () => {
        return {} as ViewerImage
      }
    },
    index: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: true
    },
    maxScale: {
      type: Number,
      default: 50
    },
    opacity: {
      type: Number,
      default: 1
    },
    overlaid: {
      type: Boolean,
      default: false
    },
    showGrid: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Object,
      default: () => {
        return {
          scale: 1,
          x: 0,
          y: 0
        }
      }
    }
  },
  data() {
    return {
      clicked: false,
      doubleClick: 0
    }
  },
  methods: {
    init() {
      const frame:any = this.$refs.frame
      frame.init()
    },
    scaleTo(scale, options) {
      const frame:any = this.$refs.frame
      frame.scaleTo(scale, options)
    },
    setTransform(zoom) {
      const frame:any = this.$refs.frame
      frame.setTransform(zoom)
    },
  },
  mounted() {
    let frame, image
    const getFrameAndImage = setInterval(() => {
      frame = document.getElementById('frame'+this.index)
      image = document.getElementById('image'+this.index)
      if (frame && image.complete) {
        // this.resetZoom(frame, image)
        clearInterval(getFrameAndImage)
      }
    })
  }
})
